<template>
    <div class="col-lg-3 col-sm-6">
        <div class="card">
            <div class="content">
                <div class="row">
                    <div class="col-xs-5">
                        <div class="icon-big text-center" :class="`icon-${type}`">
                            <i :class="icon"></i>
                        </div>

                    </div>
                    <div class="text-right col-xs-7 numbers">
                        <p>{{title}}</p>
                        {{ formatValue ? numberFormatterThousand(value) : numberFormatter(value) }}
                    </div>
                </div>
                <!--<div class="footer">-->
                <!--<hr/>-->
                <!--<div class="stats">-->
                <!--<i :class="footerIcon"></i> {{footerText}}-->
                <!--</div>-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'stats-card',
    props: {
      type: '',
      icon: '',
      title: '',
      value: '',
      footerText: '',
      footerIcon: '',
      formatValue: ''
    }

  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// StatsCard.vue?47b43412